module.exports = __webpack_public_path__ + "img/mask.29853152.png";